import { render, staticRenderFns } from "./virtual-assistant-avatar.vue?vue&type=template&id=fc01dc92&scoped=true"
import script from "./virtual-assistant-avatar.vue?vue&type=script&lang=js"
export * from "./virtual-assistant-avatar.vue?vue&type=script&lang=js"
import style0 from "./virtual-assistant-avatar.vue?vue&type=style&index=0&id=fc01dc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc01dc92",
  null
  
)

export default component.exports